import { DocFlowTableCellName } from '../../../constants/docFlow'
import i18n from '../../../i18n'
import {
  DOC_FLOW_API_URL,
  DOC_FLOW_MAX_FILES_NUMBER,
  DOC_FLOW_PDF_PAGES_LIMIT,
  DOC_FLOW_UPLOADING_ACTION_CHANGE_TYPE,
  DOC_FLOW_UPLOADING_ACTION_DELETE,
  DOC_FLOW_UPLOADING_MASS_ACTION_CHANGE_TYPE,
  DOC_FLOW_UPLOADING_MASS_ACTION_DELETE,
} from '../DocFlow.constants'
import { DocFlowUploadingTableCellName } from '../DocFlowUploadingTableRow'

import {
  DOC_FLOW_UPLOADING_TABLE_CONFIG_URL,
  DOC_FLOW_UPLOADING_TABLE_FILTER_STATE_URL,
} from './DocFlowUploading.constants'

export function getUploadingTableItemActions(item) {
  return [
    ...(isPagesOverlimit(item)
      ? []
      : [
          {
            label: 'DocumentStapling.UploadingTableChangeTypeActionOptionKey',
            value: DOC_FLOW_UPLOADING_ACTION_CHANGE_TYPE,
          },
          null,
        ]),
    {
      label: 'DocumentStapling.UploadingTableDeleteActionOptionKey',
      value: DOC_FLOW_UPLOADING_ACTION_DELETE,
    },
  ]
}

export function getUploadingTableNotificationTitle({
  action,
  count,
  totalCount,
}) {
  const types = {
    [DOC_FLOW_UPLOADING_ACTION_CHANGE_TYPE]: i18n.t(
      'Notification.CommonTitleSavedKey'
    ),
    [DOC_FLOW_UPLOADING_ACTION_DELETE]: i18n.t(
      'Notification.DocumentStaplingUploadingTitleDeleteKey'
    ),
    [DOC_FLOW_UPLOADING_MASS_ACTION_CHANGE_TYPE]: i18n.t(
      'Notification.CommonTitleMassSavedKey',
      {
        count,
        totalCount,
      }
    ),
    [DOC_FLOW_UPLOADING_MASS_ACTION_DELETE]: i18n.t(
      'Notification.CommonTitleMassDeletedKey',
      {
        count,
        totalCount,
      }
    ),
  }

  return types[action] || null
}

export function getMassActions() {
  return [
    {
      label: i18n.t('DocumentStapling.UploadingTableChangeTypeActionOptionKey'),
      value: DOC_FLOW_UPLOADING_MASS_ACTION_CHANGE_TYPE,
    },
    null,
    {
      label: i18n.t('DocumentStaplingTable.DeleteActionOptionKey'),
      value: DOC_FLOW_UPLOADING_MASS_ACTION_DELETE,
    },
  ]
}

export function isNextPhaseDisabled(entityData) {
  return (
    entityData?.[DocFlowTableCellName.DocumentsCount] < 1 ||
    !entityData?.permissions.can_move_to_next_phase
  )
}

export function isUploadingButtonDisabled(entityData) {
  return (
    entityData?.[DocFlowTableCellName.DocumentsCount] ===
      DOC_FLOW_MAX_FILES_NUMBER || !entityData?.permissions.can_attach_uploading
  )
}

export function getUploadingFilesListApi(documentId) {
  return `${DOC_FLOW_API_URL}${documentId}/uploading-files/filter/`
}

export function getUploadingTableApiUrls(id) {
  return {
    filterStateApi: `${DOC_FLOW_UPLOADING_TABLE_FILTER_STATE_URL}?object_id=${id}`,
    listApi: getUploadingFilesListApi(id),
    tableConfigApi: DOC_FLOW_UPLOADING_TABLE_CONFIG_URL,
  }
}

export function isPagesOverlimit(item) {
  return (
    item?.[DocFlowUploadingTableCellName.PagesCount] > DOC_FLOW_PDF_PAGES_LIMIT
  )
}

export function getPagesOverlimitTooltip() {
  return i18n.t('DocumentStapling.PagesOverlimitTypeTooltipTextKey')
}
